/*
 * Copyright (c) 2025. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 *
 * Contributors:
 */

export class EnumerationMappingUtility {
    static mappings = [
        {
            fields: [
                'venus:classificationDtv',
                'venus:classificationDtvP',
                'venus:classificationDehogaG',
                'venus:classificationDtvC',
            ],
            mappings: [
                ['10', 'venus:unclassified'],
                ['20', 'venus:one_star'],
                ['40', 'venus:two_star'],
                ['60', 'venus:three_star'],
                ['80', 'venus:four_star'],
                ['100', 'venus:five_star'],
            ],
        },
        {
            fields: ['venus:classificationDehoga'],
            mappings: [
                ['10', 'venus:unclassified'],
                ['20', 'venus:one_star'],
                ['30', 'venus:ne_star_superior'],
                ['40', 'venus:two_star'],
                ['50', 'venus:two_star_superior'],
                ['60', 'venus:three_star'],
                ['70', 'venus:three_star_superior'],
                ['80', 'venus:four_star'],
                ['90', 'venus:four_star_superior'],
                ['100', 'venus:five_star'],
            ],
        },
        {
            fields: [
                'venus:difficultyDescent',
                'venus:difficultyAscent',
                'venus:stamina',
                'venus:difficulty',
                'venus:drivingTechnique',
                'venus:slopeDifficulty',
            ],
            mappings: [
                ['10', 'venus:without_to_very_little'],
                ['20', 'venus:low'],
                ['30', 'venus:average'],
                ['40', 'venus:strong'],
                ['50', 'venus:very_strong'],
            ],
        },
        {
            fields: ['venus:panoramicView'],
            mappings: [
                ['10', 'venus:very_low'],
                ['20', 'venus:low'],
                ['30', 'venus:moderate'],
                ['40', 'venus:high'],
                ['50', 'venus:very_high'],
            ],
        },
        {
            fields: ['venus:classificationBauernhofSuedtirol'],
            mappings: [
                ['1flower', 'venus:one_flower'],
                ['2flowers', 'venus:three_flowers'],
                ['3flowers', 'venus:three_flowers'],
                ['3flowers', 'venus:four_flowers'],
                ['5flowers', 'venus:five_flowers'],
            ],
        },
        {
            fields: ['venus:classificationPrivatvermieterSuedtirol'],
            mappings: [
                ['1sun', 'venus:one_sun'],
                ['2suns', 'venus:two_suns'],
                ['3suns', 'venus:three_suns'],
                ['4suns', 'venus:four_suns'],
                ['5suns', 'venus:five_suns'],
            ],
        },
        // General not field specific
        ['Abdomen', 'venus:abdomen'],
        ['Bringdienst', 'venus:bring_service'],
        ['brueckenradweg', 'venus:bridge_cycle_path'],
        ['Erlebnisgastronomie', 'venus:experience_gastronomy'],
        ['eventbookedup', 'venus:booked_out'],
        ['eventcancelled', 'venus:cancelled'],
        ['eventmovedonline', 'venus:postponed_to_online_event'],
        ['eventpostponed', 'venus:postponed'],
        ['eventrescheduled', 'venus:rescheduled'],
        ['eventscheduled', 'venus:scheduled'],
    ];

    /**
     * Maps an enumeration to a new value
     * @param enumeration
     * @param field
     */
    static map(enumeration, field) {
        const mapping = this.mappings.find((m) => {
            if (Array.isArray(m)) {
                return m[0] === enumeration;
            } else {
                return m.fields.includes(field);
            }
        });

        if (mapping) {
            if (Array.isArray(mapping)) {
                return mapping[1];
            } else {
                const simpleMapping = mapping.mappings.find(
                    (m) => m[0] === enumeration
                );
                if (simpleMapping) {
                    return simpleMapping[1];
                }
            }
        }

        return enumeration;
    }
}
